module.exports = __webpack_public_path__ + "static/media/getting-support.1155ecd8.png";